import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

import { DisplayType, SummitIdObject } from '@summit/models';

import { NgTemplateOutlet } from '@angular/common';
import { Observable } from 'rxjs';
import { SummitControl } from '../../models/summit-control';
import { SFormInputCheckboxComponent } from '../s-form-input-checkbox/s-form-input-checkbox.component';
import { SFormInputCodeComponent } from '../s-form-input-code/s-form-input-code.component';
import { SFormInputDateTimeComponent } from '../s-form-input-date-time/form-input-date-time.component';
import { SFormInputDateComponent } from '../s-form-input-date/s-form-input-date.component';
import { SFormInputDurationComponent } from '../s-form-input-duration/s-form-input-duration.component';
import { SFormInputEnumComponent } from '../s-form-input-enum';
import { SFormInputHiddenComponent } from '../s-form-input-hidden/s-form-input-hidden.component';
import { SFormInputNumberComponent } from '../s-form-input-number/s-form-input-number.component';
import { SFormInputTextComponent } from '../s-form-input-text/s-form-input-text.component';
import { SFormInputTimeComponent } from '../s-form-input-time/s-form-input-time.component';

@Component({
  selector: 's-form-input',
  templateUrl: './s-form-input.component.html',
  styleUrls: ['./s-form-input.component.css'],
  standalone: true,
  imports: [
    SFormInputCheckboxComponent,
    SFormInputNumberComponent,
    SFormInputTextComponent,
    SFormInputCodeComponent,
    SFormInputEnumComponent,
    SFormInputDateComponent,
    SFormInputDateTimeComponent,
    SFormInputHiddenComponent,
    SFormInputDurationComponent,
    SFormInputDurationComponent,
    SFormInputTimeComponent,
    NgTemplateOutlet
  ]
})
export class SFormInputComponent<T extends SummitIdObject> extends SummitControl<T> implements OnInit {
  //@HostBinding('class.grow-1') flexGrow = true;
  //@HostBinding('class.flex-col') flexColumn = true;
  //@HostBinding('class.bg-green-500') flexColumn2 = true;
  displayType = DisplayType;
  @Input() enumObject: number[];
  @Input() sort: boolean;
  @Input() allowZero: boolean;
  @Input() splitInputs: boolean;
  @Input() increment: number;
  @Input() filter: number[];
  @Input() maxFractionDigits: number;
  @Input() filter$: Observable<string[]>;
  @Output() blurEvent = new EventEmitter<any>();
  @ContentChild('prefix') parentPrefix: TemplateRef<unknown>;
  @ContentChild('suffix') parentSuffix: TemplateRef<unknown>;
}
